import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { ImageType, RequestsI } from '../types';
import { downloadUserImage } from '../utils/functions';
import { doesPeriodContainToday } from '../utils/formatDateAndTime';
import { notification, NotificationType } from '@iba-team/portal-react-components/dist';
import i18n from '../i18n';
import { AbsenceStore } from './Absence';
class Requests {
  constructor() {
    makeAutoObservable(this);
  }
  requestsList: RequestsI[] = [];

  allowedExtensions: string[] = [];
  areExtensionsFetched = false;

  images: ImageType[] = [];
  isRequestsFetched = false;
  isRequestElementsAvatarsFetched = false;
  temporaryRequests: RequestsI[] = [];
  getRequests = async () => {
    try {
      this.isRequestsFetched = false;
      this.requestsList = await apiConfig.requestService.getRequestList();
      this.isRequestsFetched = true;
    } catch (e) {
      this.isRequestsFetched = false;
      throw new Error('Error! Couldn\'t get requests!');
    }
  };

  fetchPortraitUrl = async () => {
    const uniqArray: string[] = [];
    this.requestsList.forEach((req) => {
      if(!uniqArray.includes(req.portraitUrl)){
        uniqArray.push(req.portraitUrl);
      }
    });
    const prepareArray = uniqArray.map(evt=> downloadUserImage(evt));
    const imagesResult = Promise.all(prepareArray);
    try {
      this.isRequestElementsAvatarsFetched = false;
      const res = await imagesResult;
      this.images = res.map(i => {
        return {originalUrl: i.imgUrl, blob: i.blob};
      });
      this.isRequestElementsAvatarsFetched = true;
    }
    catch (e) {
      this.isRequestElementsAvatarsFetched = false;
    }
  };
  approveRequest = async (id: number, startDate: string, endDate: string) => {
    const requestById = this.requestsList.find(r => r.id === id);
    const isInInterval = doesPeriodContainToday(startDate, endDate);
    const {checkedNodes, getAbsenceLists} =  AbsenceStore;

    if(requestById){
      this.temporaryRequests.push(requestById);
      apiConfig.requestService.approveRequest(id).then(() => {
        notification.open({
          type: NotificationType.SUCCESS,
          title: i18n.t('success'),
          description: i18n.t('requestApproved')
        });
        if(isInInterval){
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          const prepare = checkedNodes.map(i => ({listName: i.title, listType: i.type, plannerListId: typeof(i.key) === 'number' ? i.key : null}));
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          getAbsenceLists(prepare);
        }
        this.temporaryRequests = this.temporaryRequests.filter(r => r.id !== id);
        this.deleteRequest(id);
      }).catch(() => {
        this.temporaryRequests = this.temporaryRequests.filter(r => r.id !== id);
        notification.open({
          type: NotificationType.ERROR,
          title: i18n.t('errorHeader'),
          description: i18n.t('errorMsg')
        });
      });
    }
  };

  rejectRequest = async (id: number, comment: string) => {
    const requestById = this.requestsList.find(r => r.id === id);
    if(requestById){
      this.temporaryRequests.push(requestById);
      await apiConfig.requestService.rejectRequest(id, comment).then(() => {
        notification.open({
          type: NotificationType.SUCCESS,
          title: i18n.t('success'),
          description: i18n.t('requestRejected')
        });
        this.temporaryRequests = this.temporaryRequests.filter(r => r.id !== id);
        this.deleteRequest(id);
      }).catch(() => {
        this.temporaryRequests = this.temporaryRequests.filter(r => r.id !== id);
        notification.open({
          type: NotificationType.ERROR,
          title:  i18n.t('errorHeader'),
          description: i18n.t('errorMsg')
        });
      });
    }
  };

  deleteRequest = async (id: number) => {
    this.requestsList = this.requestsList.filter(i => i.id !== id);
  };

  cancelRequest = async (id: number, comment: string) => {
    await apiConfig.requestService.cancelRequest(id, comment);
  };

  fetchAllowedExtensions = async () => {
    if(!this.areExtensionsFetched){
      try {
        this.areExtensionsFetched = false;
        this.allowedExtensions = await apiConfig.extensionsService.fetchAllowedExtensions();
        this.areExtensionsFetched = true;
      } catch (e) {
        this.areExtensionsFetched = false;
        throw new Error('Error! Couldn\'t get allowed extensions!');
      }
    }    
  };
}

export const RequestsStore = new Requests();
